import { PaginationState } from "@tanstack/react-table";
import classNames from "classnames";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { setBlocker, clearBlocker } from '../../../shared/slice/blockerSlice'
import { useBlocker, useNavigate, useParams } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import DocumentsService, {
  deleteMarksPersonalization,
} from "../../../common/api/documentsApi";
import ModalButton from "../../../shared/Ui/Buttons/ModalButtons";
import { EmptyListPlaceholderContent } from "../../../shared/Ui/EmptyPageBlock";
import ModalComponent from "../../../shared/Ui/ModalComponent/ModalWindow";
import Stepper from "../../../shared/components/Stepper/Stepper";
import Pagination from "../../../shared/components/Table/Pagination";
import { ITable } from "../../../shared/components/Table/types";
import { useAppSelector } from "../../../shared/hook/useAppSelector";
import { CheckResult } from "../Upload/CheckResults/CheckResult";
import { DocumentUpload } from "../Upload/DocumentUpload/DocumentUpload";
import { DocumentsSearch } from "../Upload/DocumentsSearch/DocumentsSearch";
import { MarkScan } from "../Upload/MarkScan/MarkScan";
import style from "./ProductPersonalization.module.css";
// @ts-ignore
import { NCALayerClient } from "ncalayer-js-client";
import {
  getDocumentXMLForPersSigning,
  getDocumentXMLForSigning,
  saveSignedDocumentXML,
} from "../../../common/api/documentSignature";
import { createDocument } from "../../../common/api/notificationApi";
import { normalizedLocale } from "../../../common/libs/normalizedLocale";
import AlertBox from "../../../shared/Ui/AlertBox/AlertBox";
import Loader from "../../../shared/Ui/Loader/Loader";
import StatusBadge from "../../../shared/Ui/StatusBadge/StatusBadge";
import { useAppDispatch } from "../../../shared/hook";
import { deleteDataDocument } from "./../../../shared/slice/documentState";
import { submitXmlProduct } from "../../../shared/signature/documentsSignature";
import CheckBox from "../../../shared/Ui/CheckBox/CheckBox";
import { Field, Form, Formik } from "formik";
import {
  getPersonalizationProductById,
  getProductMarks,
} from "../../../common/api/nktApi";
import AddByOrderNumber from "../Upload/AddByOrderNumber/AddByOrderNumber";
import { number } from "yup";
import PageNotRole from "../../../shared/Ui/PageNotFound/PageNotRole";
import { getDescription, getStatusType } from "../../../shared/documentUtils/dictionary";
import Cookies from "js-cookie";
import { personalization_groups } from "../../../shared/reference/personalization_groups";
import { product_groups } from "../../../shared/reference/product_groups";
import CalendarSelectFormik from "../../../shared/Ui/Calendar/CalendarSelectFormik";
import SelectCustomFormik from "../../../shared/Ui/SelectCustom/SelectCustomFormik";
import { getDerivativeSourceList } from "../../../common/api/nktApi";
import { checkBalloonCode } from "../../../common/api/baloonsApi";

type GasCylinderIdInputProps = {
  disabled: boolean;
  value: any;
  onChange: (nextValue: any) => void;
  onDebouncedCheck: (val: string | number) => void | Promise<void>;
};

const GasCylinderIdInput: React.FC<GasCylinderIdInputProps> = ({
  disabled,
  value,
  onChange,
  onDebouncedCheck,
}) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  return (
    <input
      type="number"
      min={0}
      step={1}
      disabled={disabled}
      value={value ?? ""}
      onChange={(e) => {
        const raw = e.target.value;
        const nextValue = raw === "" ? "" : Number(raw);
        onChange(nextValue);
        if (timerRef.current) clearTimeout(timerRef.current);
        if (raw === "") return;
        timerRef.current = setTimeout(() => {
          onDebouncedCheck(nextValue);
        }, 500);
      }}
      className={`w-full border-gray-300 text-black placeholder-gray-400 text-center p-[20px] ${style.placeholder}`}
      placeholder="Инвентарный номер ГБ"
    />
  );
};

 

function ProductPersonalizationOrders() {
  const dispatch = useAppDispatch();
  const documentState = useAppSelector((state) => state.documentState);
  const userData: any = useAppSelector((state) => state.auth.userData);
  const { t, i18n } = useTranslation();
  const locale = normalizedLocale(i18n.language);
  const navigate = useNavigate();
  const { ProductPersonalizationId, jewelryId } = useParams();
  const [tableData, setTableData] = useState<ITable>();
  const pageSize = useAppSelector((state) => state.userSettings.pageSize);
 
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: pageSize,
  });
  const [errorModal, setErrorModal] = useState<any>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<any>(null);
  const [isDocumentSearchModalOpen, setIsDocumentSearchModalOpen] =
    useState<boolean>(false);
  const [isFileUploadModalOpen, setIsFileUploadModalOpen] =
    useState<boolean>(false);
  const [isMarkScanModal, setIsMarkScanModal] = useState<boolean>(false);
  const [isCheckOpen, setIsCheckOpen] = useState<any>(null);
  const [status, setStatus] = useState<any>("new");
  const [isFormChanged, setIsFormChanged] = useState<boolean>(false);
  const [toggleOnLoad, setToggleOnLoad] = useState<boolean>(false);
  const [alertOpen, setAlertOpen] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteMarks, setDeleteMarks] = useState<number[]>([]);
  const [isOrderNumberModal, setIsOrderNumberModal] = useState<boolean>(false);
  const [stackEdit, setStackEdit] = useState<any>([]);
  const [role, setRole] = useState<any>(null);
  const [sourceCodeOptions, setSourceCodeOptions] = useState<any[]>([]);
  const roleMatrix = useAppSelector((state) => state.roleMatrix);
  const [statusType, setStatusType] = useState({
    type: "new",
    label: t("documentStatus.new"),
  });
  const [initialValues, setInitialValues] = useState<any>({
    id: null, // ИД
    refDocType: 6,
    marks: [],

    refPutReason: null, //Причина вывода из оборота
    foundationDocumentName: null,
    foundationDocumentNumber: null,
    foundationDocumentDate: null,
    note: null, // Примечание

    orgId: "",
    createUser: "",
    createdAt: "",
    // updatedAt: "",
    // signingAt: "",
    receiver: "",
    sender: "",
    status: "new",
  });

console.log(initialValues);

  const getActiveGroupCode = (): string | null => {
    const raw = Cookies.get("activeGroupCode");
    return raw ?? null;
  };

  const getActivePersonalizationFields = () => {
    // Prefer productGroupId from loaded document, fallback to cookies
    const docProductGroupId = Number(initialValues?.productGroupId ?? "");
    const activeGroupCode = getActiveGroupCode();
    const activeGroupIdFromCookie = Number(Cookies.get("activeGroup") ?? "");

    const currentProdGroup: any =
      (Number.isFinite(docProductGroupId) && product_groups.find((pg: any) => pg.id === docProductGroupId))
      || (activeGroupCode && product_groups.find((pg: any) => pg.code === activeGroupCode))
      || (Number.isFinite(activeGroupIdFromCookie) && product_groups.find((pg: any) => pg.id === activeGroupIdFromCookie))
      || product_groups[0];

    const currentPersGroup: any =
      (currentProdGroup?.code && personalization_groups.find((pg: any) => pg.code === currentProdGroup.code))
      || (currentProdGroup?.code && personalization_groups.find((pg: any) => pg.code === currentProdGroup.code))
      || personalization_groups[0];

    return currentPersGroup?.categories?.find((c: any) => c.key === "personalization")?.fields ?? [];
  };

  const computeAutoValue = (autoSource: string) => {
    if (autoSource === "documentCreatedAt") {
      // always default to today's date
      return format(new Date(), "dd.MM.yyyy");
    }
    if (autoSource === "currentUser") {
      const name = userData?.userName || "";
      const surname = userData?.userSurname || "";
      return `${name} ${surname}`.trim();
    }
    return "";
  };

  useEffect(() => {
    const persFields = getActivePersonalizationFields();
    const autoFields = persFields.filter((f: any) => f.auto && f.value);
    if (!autoFields.length) return;
    if (!Array.isArray(initialValues?.marks)) return;

    const nextMarks = initialValues.marks.map((m: any) => {
      const updated = { ...m };
      autoFields.forEach((f: any) => {
        // fill only when empty to allow user overwrite
        if (updated[f.value] == null || updated[f.value] === "") {
          updated[f.value] = computeAutoValue(f.autoSource);
        }
      });
      return updated;
    });

    const changed = JSON.stringify(nextMarks) !== JSON.stringify(initialValues.marks);
    if (changed) {
      setInitialValues((prev: any) => ({ ...prev, marks: nextMarks }));
    }
  }, [initialValues.createdAt, initialValues.marks, userData]);

console.log(777,roleMatrix);
  useEffect(() => {
    // const roleObj = () => {
    //   const roleDocItem = roleMatrix?.roleMatrix?.find((item) => item.id === 4);
    //   const roleDraftItem = roleMatrix?.roleMatrix?.find((item) => item.id === 7);
      
    //   return {
    //     roleDoc: roleDocItem?.specificAction?.documents[2],
    //     roleDraft: roleDraftItem,
    //   };
    // };
    const roleObj = () => {
      let roleWithSpecificAction = roleMatrix?.roleMatrix?.find((item) => item.id === 12)
      let roleDraft = roleMatrix?.roleMatrix?.find((item) => item.id === 7);
      if(!roleWithSpecificAction.view){
        roleWithSpecificAction = roleMatrix?.roleMatrix?.find((item) => item.id === 7)
      }
      return {
        roleDoc: roleWithSpecificAction?.specificAction?.documents?.[0] || false,
        roleDraft: roleDraft || false,
        roleAccepted: roleWithSpecificAction || false
      };
    };
    setRole(roleObj());
console.log('roleObj',role);

    onLoad();
    (async () => {
      try {
        const data = await getDerivativeSourceList();
        const opts = Array.isArray(data)
          ? data.map((item: any) => ({
              label: item.code + " - " + item?.shortName || "",
              value: item?.code ?? item?.id,
            }))
          : [];
        setSourceCodeOptions(opts);
      } catch (e) {
        console.error("Failed to load derivative-source reference", e);
        setSourceCodeOptions([]);
      }
    })();
    if (documentState.isSafe) {
      dispatch(setBlocker(true))
      setIsFormChanged(true);
    }
  }, [
    isDocumentSearchModalOpen,
    isMarkScanModal,
    isCheckOpen,
    CheckResult,
    navigate,
    toggleOnLoad,
  ]);

  console.log(initialValues);

  const handleProductChange = (
    index: any,
    field: string,
    value: any,
    formik: any,
  ) => {
    if (formik.values.marks[index].id) {
      setStackEdit((prev: any) => {
        const updatedProducts = [...prev];
        const productIndex = updatedProducts.findIndex(
          (product) => product.id === formik.values.marks[index].id,
        );
        if (productIndex >= 0) {
          updatedProducts[productIndex] = {
            ...updatedProducts[productIndex],
            [field]: value,
          };
        } else {
          updatedProducts.push({
            ...formik.values.marks[index],
            [field]: value,
          });
        }
        console.log(updatedProducts, "updatedProducts");
        return updatedProducts;
      });
    }
  };

  async function onLoad() {
    if (ProductPersonalizationId !== undefined && jewelryId !== undefined) {
      await getProductMarks(
        ProductPersonalizationId,
        jewelryId,
        // pagination?.pageIndex + 1,
        // pagination.pageSize,
      )
        .then((response) => {
          if (response) {
            setTableData({
              values: response?.marks,
              currentPage: response?.currentPage,
              itemsPerPage: response?.itemsPerPage,
              totalItems: response?.totalItems,
              totalPages: response?.totalPages,
            });
            setInitialValues((prev: any) => ({
              ...prev,
              marks: response?.marks,
              currentPage: response?.currentPage,
              itemsPerPage: response?.itemsPerPage,
              totalItems: response?.totalItems,
              totalPages: response?.totalPages,
            }));
          }
        })
        .catch((error) => {
          console.error("Error fetching marks from document:", error),
            setTableData({
              values: [],
              currentPage: 0,
              itemsPerPage: 0,
              totalItems: 0,
              totalPages: 0,
            });
        });

      await getPersonalizationProductById(jewelryId)
        .then((documentResponse) => {
          setInitialValues((prev: any) => ({
            ...prev,
            productInfo: documentResponse,
          }));
        })
        .catch((error) => {
          // navigate("/404");
        });

      await DocumentsService.getDocument(ProductPersonalizationId)
        .then((documentResponse) => {
          const { type, label } = getStatusType(documentResponse.data.status,t);
          setStatusType({ type, label });
          setInitialValues((prev: any) => ({
            ...prev,
            ...documentResponse.data,
          }));
          setStatus(documentResponse.data.status);
        })
        .catch((error) => {
          setErrorModal({
            singleError: true,
            errorMessage: error
              ? error
              : t("documentNotification.unknown_error"),
          });
        });
    }
  }


  // Подписание заявки
  async function submitXmlProduct() {
    const ncalayerClient = new NCALayerClient();
    try {
      await ncalayerClient.connect();
    } catch (error) {
      setAlertOpen({
        status: "error",
        message: t("documentNotification.nca_no_connect"),
      });
      return;
    }

    let xml;
    try {
      setIsLoading(true);
      xml = await getDocumentXMLForPersSigning(ProductPersonalizationId);
      console.log("xml", xml);
      if (!xml || !xml.data) {
        console.log("Не удалось получить XML документ для подписи.");
        return;
      }
      if (xml.data.errorFields && xml.data.errorFields?.length > 0) {
        setErrorModal(xml.data.errorFields);
        console.log("xml1", xml.data.errorFields);
        return;
      }
      if (xml.data.problemMarks && xml.data.problemMarks?.length > 0) {
        setIsCheckOpen(xml.data.problemMarks);
        console.log("xml2", xml.data.problemMarks);
        return;
      }
    } catch (error: any) {
      setErrorModal({
        singleError: true,
        errorMessage: error.message
          ? error.message
          : t("documentNotification.unknown_error"),
      });
      return;
    } finally {
      setIsLoading(false);
    }
    let xmlSignature;
    try {
      xmlSignature = await ncalayerClient.basicsSignXML(
        NCALayerClient.basicsStoragesAll,
        xml.data.xml,
        NCALayerClient.basicsXMLParams,
        process.env.REACT_APP_ETRACK_TEST === "true"
          ? NCALayerClient.basicsSignerTestAny
          : NCALayerClient.basicsSignerSignAny,
        "ru",
      );
      console.log("Подпись XML:", xmlSignature[0]);
    } catch (error: any) {
      setErrorModal(error.data.message);
      return;
    }

    try {
      setIsLoading(true);
      const documentIdValue = ProductPersonalizationId ?? "0";
      await saveSignedDocumentXML(documentIdValue, xmlSignature[0]);
      alert(t("documentNotification.document_xml_success"));
      navigate(`/documents/personalization`);
    } catch (error) {
      const e = error as { response?: { data?: { message?: string } } }; // Утверждаем тип
      console.log("e", e);
      const errorMessage = e.response?.data;
      alert(t("documentNotification.document_xml_error"));
      console.log("errorka", errorMessage);
      setErrorModal({
        singleError: true,
        errorMessage: errorMessage?.message
          ? errorMessage?.message
          : t("documentNotification.unknown_error"),
      });
    } finally {
      setIsLoading(false);
    }
  }

  async function submitCreate(formikValues: any) {
    const sanitizeMarksForCurrentGroup = (marks: any[]) => {
      const persFields = getActivePersonalizationFields();
      const allowedFieldKeys = new Set([
        ...persFields.map((f: any) => f.value),
        "id",
        "markCode",
      ]);
      return (marks || []).map((mark: any) => {
        const result: any = {};
        for (const key of allowedFieldKeys) {
          const value = mark?.[key as any];
          if (value !== null && value !== undefined && value !== "") {
            result[key as any] = value;
          }
        }
        return result;
      });
    };

    const backendData = {
      marks: sanitizeMarksForCurrentGroup(formikValues.marks),
    };
    if (ProductPersonalizationId && jewelryId) {
      if(stackEdit?.length>0)
        {const sanitizedEdits = sanitizeMarksForCurrentGroup(stackEdit);
        await DocumentsService.editDocumentPersonalization(
        ProductPersonalizationId,
        jewelryId,
        sanitizedEdits,
      )
        .then((response) => {
          dispatch(clearBlocker())
          setIsFormChanged(false);
          dispatch(deleteDataDocument());
          onLoad();
          setAlertOpen({
            status: "SUCCESS",
            message: t("documentNotification.document_edited_success"),
          });
        })
        .catch((error) => {
          console.error("Error creating new invoice:", error);
          setAlertOpen({
            status: "error",
            message: error?.response?.data?.message
              ? error?.response?.data?.message
              : t("documentNotification.document_edit_error"),
          });
        });
    }}
    if (!ProductPersonalizationId) {
      const create = await createDocument(backendData)
        .then((response) => {
          dispatch(clearBlocker())
          setIsFormChanged(false);
          dispatch(deleteDataDocument());
          navigate(
            `/documents/inventory-resumption/${response.data.document.id}/orders`,
          );
          setAlertOpen({
            status: "SUCCESS",
            message: t("documentNotification.document_saved_success"),
          });
        })
        .catch((error) => {
          console.error("Error creating new invoice:", error);
          setAlertOpen({
            status: "error",
            message: error?.response?.data?.message
              ? error?.response?.data?.message
              : t("documentNotification.document_save_error"),
          });
        });
    }
  }

  const getDocument = async () => {
    try {
      if (ProductPersonalizationId) {
        setIsLoading(true);
        const fileBlob = await DocumentsService.downloadDocumentMarks(
          ProductPersonalizationId,
        );
        const downloadUrl = window.URL.createObjectURL(fileBlob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", `${initialValues?.docNumber}.xlsx`);
        document.body.appendChild(link);
        link.click();
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      }
    } catch (error) {
      setAlertOpen({
        message: error ? error : "Ошибка при скачивании файла:",
      });
      console.error("Ошибка при скачивании файла:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const checkboxDelete = (id: any) => {
    setDeleteMarks((prevDeleteMarks: any) => {
      if (prevDeleteMarks.includes(id)) {
        return prevDeleteMarks.filter((item: any) => item !== id);
      } else {
        return [...prevDeleteMarks, id];
      }
    });
  };

  const fullDeleteMarks = () => {
    setDeleteMarks([]);
    if (initialValues?.marks) {
      const allIds = initialValues?.marks.map((value: any) => value.id);
      setDeleteMarks(allIds);
    }
    if (deleteMarks?.length === initialValues?.marks?.length) {
      setDeleteMarks([]);
    }
  };

  const handleDelete = (docId?: string, jewelryId?: any, marks?: number[]) => {
    if (typeof docId !== undefined && marks) {
      DocumentsService.deleteMarksPersonalization(docId, jewelryId, marks)
        .then((response) => {
          if (tableData?.currentPage === tableData?.totalPages) {
            setPagination((prevState) => ({
              ...prevState,
              pageIndex:
                prevState.pageIndex === 0
                  ? prevState.pageIndex
                  : prevState.pageIndex - 1,
            }));
          }
          setDeleteMarks([]);
        })
        .catch((error) =>
          console.log(`Error deleting mark from document:" ${error}`),
        )
        .finally(() => {
          setIsDeleteModalOpen(null);
          onLoad();
        });
    } else {
      setErrorModal(t("documentNotification.no_id_error"));
      setIsDeleteModalOpen(null);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (isFormChanged) {
        event.preventDefault();
        event.returnValue = t("documentNotification.unsaved_changes_warning");
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isFormChanged]);
  const { isBlocked, proceed } = useAppSelector((state) => state.blocker);
  let blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isBlocked !== false && // и если форма изменена

      currentLocation.pathname !== nextLocation.pathname &&
      !nextLocation.pathname.includes("inventory-resumption"),
  );

  if (isLoading && !role) return <Loader />;

  if (!role || !role?.roleAccepted?.view) {
    return <PageNotRole />;
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => { }}
      enableReinitialize={true}
      validateOnBlur={true}
      validateOnChange={true}
    >
      {(formik) => {
        const docProductGroupId = Number(formik?.values?.productGroupId ?? initialValues?.productGroupId ?? "");
        const activeGroupCode = Cookies.get("activeGroupCode") ?? null;
        const activeGroupIdFromCookie = Number(Cookies.get("activeGroup") ?? "");

        const currentProdGroup: any =
          (Number.isFinite(docProductGroupId) && product_groups.find((pg: any) => pg.id === docProductGroupId))
          || (activeGroupCode && product_groups.find((pg: any) => pg.code === activeGroupCode))
          || (Number.isFinite(activeGroupIdFromCookie) && product_groups.find((pg: any) => pg.id === activeGroupIdFromCookie))
          || product_groups[0];

        const currentPersGroup: any =
          (currentProdGroup?.code && personalization_groups.find((pg: any) => pg.code === currentProdGroup.code))
          || (currentProdGroup?.code && personalization_groups.find((pg: any) => pg.code === currentProdGroup.code))
          || personalization_groups[0];

        const persFields = currentPersGroup?.categories?.find((c: any) => c.key === "personalization")?.fields ?? [];
        const getFieldLabel = (field: any) => (i18n.language?.includes("kk") ? (field.labelKz || field.labelRu) : field.labelRu);
        const isEditable = (field: any) => ((formik.values.status === "new" || formik.values.status === "DRAFT") && (role?.roleDraft?.edit));
        const getInputType = (fieldKey: string) => {
          if (/date/i.test(fieldKey)) return "date";
          if (/weight|size|volume|length|grams|millimeters|number/i.test(fieldKey)) return "number";
          return "text";
        };

        return (
          <Form className="max-w-[1585px] w-full m-t-[20px]">
            <div className="max-w-[1585px] w-full m-t-[20px]">
            {isBlocked && blocker.state === "blocked" ? (
               <ModalComponent
               isOpen={true} // Модальное окно всегда открыто, когда blocker.state === "blocked"
               onClose={() => {
                 if (blocker && typeof blocker.reset === "function") {
                   blocker.reset();
                 } else {
                   console.error("Reset function is not available.");
                 }
               }}
               headerContent={
                 <>
                   <span>{t("documentNotification.notification")}</span>
                   <button
                     type="button"
                     onClick={() => {
                       if (blocker && typeof blocker.reset === "function") {
                         blocker.reset();
                       } else {
                         console.error("Reset function is not available.");
                       }
                     }}
                     aria-label="Close"
                     className="float-right cursor-pointer bg-none border-none"
                   >
                     &times; {/* Символ крестика */}
                   </button>
                 </>
               }
               content={<p>{t("documentNotification.unsaved_changes_warning")}</p>}
               customContent={
                 <>
                  <ModalButton
         type="button"
         onClick={() => {
          dispatch(clearBlocker())
           if (blocker && typeof blocker.proceed === "function") {
             blocker.proceed(); // Уходим со страницы без сохранения
           } else {
             console.error("Proceed function is not available.");
           }
         }}
       >
         {t("mainButtons.cancel")}
       </ModalButton>
                   <ModalButton
                     type="button"
                     color="green"
                     onClick={async () => {
                      dispatch(clearBlocker())
                       try {
                         await submitCreate(formik.values); // Сохранение данных
                         if (blocker && typeof blocker.proceed === "function") {
                           blocker.proceed(); // Переход после сохранения
                         }
                       } catch (error) {
                         console.error("Error saving data:", error);
                         // Можно обработать ошибку, например, показать уведомление пользователю
                       }
                     }}
                   >
                     {t("mainButtons.save")}
                   </ModalButton>
                 </>
               }
             />
              ) : null}
              <div className="flex flex-col gap-[10px]">
                <div className="flex flex-row text-[20px] font-bold gap-[6px] text-gray-700 ">
                  <div>
                    {ProductPersonalizationId ? (
                      <div className="flex gap-[20px]">
                        <div className="flex flex-col">
                          <StatusBadge type={statusType.type}>
                            {t("documentLabels.status") +
                              ": " +
                              statusType.label}
                          </StatusBadge>
                          {(initialValues?.signingAt ||
                            initialValues?.createdAt) && (
                              <div className="text-[14px] font-semibold text-gray-700 ml-[9px]">
                                {format(
                                  new Date(
                                    initialValues?.signingAt ||
                                    initialValues?.createdAt,
                                  ),
                                  "dd.MM.yyyy, HH:mm",
                                )}
                              </div>
                            )}
                        </div>
                        <span className="flex gap-[10px]">
                          <div>{getDescription(initialValues.refDocType,t)}:</div>
                          <div>
                            {initialValues.docNumber
                              ? initialValues.docNumber
                              : " " + t("mainLabels.not_generated")}
                          </div>
                        </span>
                      </div>
                    ) : (
                      <div className="flex gap-[20px]">
                        <StatusBadge type={statusType.type}>
                          {t("documentLabels.status") + " " + statusType.label}
                        </StatusBadge>
                        <div>
                          {t("documentLabels.create_document")}
                          {": "}
                          {t("documentType.product_personalization")}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-row flex-wrap justify-between ">
                  <div className="my-auto">
                    <Stepper
                      steps={[
                        t("productPersonalization.productGroups"),
                        t("productPersonalization.brands"),
                        t("productPersonalization.signature"),
                      ]}
                      currentStep={2}
                    />
                  </div>

                  <div className="flex flex-row gap-[20px] flex-wrap">
                    {ProductPersonalizationId &&
                      status === "PROCESSED" &&
                      tableData?.totalItems &&
                      tableData?.totalItems > 0 ? (
                      <button
                        className="bg-green hover:brightness-75 text-white font-bold py-2 px-4 rounded"
                        type="button"
                        onClick={() => getDocument()}
                      >
                        {t("documentLabels_3.download_marks")}
                      </button>
                    ) : null}
                    <button
                      className="bg-bg hover:brightness-75 text-gray-500 font-bold py-2 px-4 rounded"
                      type="button"
                      onClick={() => {
                        status == "DRAFT" ?
                          navigate(`/documents/drafts`) : navigate(`/documents/personalization`)
                      }}
                    >
                      {t("mainButtons.close")}
                    </button>
                    <button
                      className="bg-bg hover:brightness-75 text-gray-500 font-bold py-2 px-4 rounded"
                      type="button"
                      onClick={() =>
                        ProductPersonalizationId
                          ? navigate(
                            `/documents/personalization/${ProductPersonalizationId}`,
                          )
                          : navigate(`/documents/personalization/new`)
                      }
                    >
                      {t("mainButtons.back")}
                    </button>
                    {((formik.values.status === "new" &&
                      role.roleDraft.edit) ||
                      (formik.values.status == "DRAFT" &&
                        role.roleDraft.edit)) && (
                        <div className="flex flex-row gap-[20px] flex-wrap">
                          <button
                            className="bg-green hover:brightness-75 text-white font-bold py-2 px-4 rounded"
                            type="button"
                            onClick={() => submitCreate(formik.values)}
                          >
                            {t("mainButtons.save")}
                          </button>
                        </div>
                      )}
                  </div>
                </div>
                <div className="flex flex-col bg-white  my-3 px-5 pb-3 relative rounded-xl shadow-md  gap-[20px]">
                  <div className=" my-5 relative flex flex-row align-center gap-x-[20px]">
                    {(status === "new" || status === "DRAFT") && role.roleDraft.edit && (
                      <div className="flex  gap-[20px]">
                        <button
                        type="button"
                        onClick={() => {

                          submitCreate(formik.values);
                          
                          dispatch(deleteDataDocument());
                        }}
                          className=" bg-green text-white font-semibold py-2 px-4 rounded min-w-[180px] h-[40px]"
                          data-tooltip-offset={4}
                          data-tooltip-id="document-type"
                        >
                          {t("documents_orders.add_products")}
                        </button>
                        {deleteMarks?.length > 0 && role.roleDraft.edit && (
                          <button
                            onClick={() => setIsDeleteModalOpen(deleteMarks)}
                            className=" bg-bg hover:brightness-75 text-gray-500 font-bold py-2 px-4 h-[40px] min-w-[280px] rounded"
                          >
                            {t("documents_orders.delete_products")}
                          </button>
                        )}
                        <div className="z-[1000] relative	">
                          <Tooltip
                            id="document-type"
                            className={classNames(
                              style.wrapperTooltip,
                              "drop-shadow-2xl",
                            )}
                            openOnClick={true}
                            clickable={true}
                            noArrow={true}
                            opacity={1}
                            place={"bottom-end"}
                          >
                            <div
                              className={classNames(
                                style.tooltip,
                                "flex flex-col min-w-[208px] p-0 rounded-lg relative left-[21px] overflow-hidden",
                              )}
                            >
                              <button
                                type="button"
                                className={classNames(
                                  "flex h-10 items-center px-4 duration-200 text-sm justify-between",
                                )}
                                onClick={() => setIsFileUploadModalOpen(true)}
                              >
                                <span>
                                  {t("documents_orders.upload_from_file")}
                                </span>
                              </button>
                              <button
                                className={classNames(
                                  "flex h-10 items-center px-4 duration-200 text-sm justify-between",
                                )}
                                onClick={() =>
                                  setIsDocumentSearchModalOpen(true)
                                }
                              >
                                <span>{t("documents_orders.add_codes")}</span>
                              </button>
                              <button
                                className={classNames(
                                  "flex h-10 items-center px-4 duration-200 text-sm justify-between",
                                )}
                                onClick={() => setIsMarkScanModal(true)}
                              >
                                <span>{t("mark_scan.scan_codes")}</span>
                              </button>
                              <button
                                className={classNames(
                                  "flex h-10 items-center px-4 duration-200 text-sm justify-between",
                                )}
                                onClick={() => setIsOrderNumberModal(true)}
                              >
                                <span>
                                  {t("documents_orders.by_order_number")}
                                </span>
                              </button>
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                    )}
                    <h2 className="text-[18px] font-medium text-gray-700 self-center ">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: initialValues.productInfo
                            ? `<strong>Номер</strong>: ${initialValues.productInfo.ntin}
                               <strong>${t("documents_upload.ntin")}</strong>: ${initialValues.productInfo.productTypeCode}
                               <strong>${t("productPersonalization.orderName")}:</strong> ${initialValues.productInfo.name}`
                            : "",
                        }}
                      />
                    </h2>
                  </div>
                  <div className="w-full">
                    <div className="rounded-lg  bg-white">
                      <table className="max-w-full w-full leading-normal table-fixed">
                        <thead className="border-b-2 border-gray-300">
                          <tr>
                            {(status === "new" ||
                              (status === "DRAFT" &&
                                formik.values.marks?.length !== 0)) && (
                                <th
                                  className={`px-3 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 ${style.checkboxCol}`}
                                  scope="col"
                                >
                                  <CheckBox
                                    checked={
                                      deleteMarks?.length ===
                                      tableData?.values?.length
                                    }
                                    onChange={() => {
                                      fullDeleteMarks();
                                    }}
                                  />
                                </th>
                              )}
                            <th
                              className={`px-3 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 ${style.indexCol}`}
                              scope="col"
                            >
                              №{t("documents_orders.number")}
                            </th>
                            <th
                              className={`px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 ${style.codeCol}`}
                              scope="col"
                            >
                              {t("documents_orders.code")}
                            </th>
                            {persFields.map((field: any, idx: number) => (
                              <th
                                key={`hdr-${idx}-${field.value}`}
                                className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                scope="col"
                              >
                                {getFieldLabel(field)}
                              </th>
                            ))}
                            <th
                              className={`px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 ${style.trash} `}
                              scope="col"
                            ></th>
                          </tr>
                        </thead>
                        <tbody className="font-normal text-center">
                          {formik.values.marks.length > 0 ? (
                            formik.values.marks
                              .slice(
                                pagination.pageIndex * pagination.pageSize,
                                (pagination.pageIndex + 1) *
                                pagination.pageSize,
                              )
                              .map((value: any, index: any) => {
                                const i =
                                  pagination.pageIndex * pagination.pageSize +
                                  index;
                                const reverseIndex =
                                  formik.values.marks?.length -
                                  (pagination.pageIndex * pagination.pageSize +
                                    index);
                                return (
                                  <tr key={`tr-${index}-${value.id}`}>
                                    {(status === "new" ||
                                      status === "DRAFT") && (
                                        <td className={`px-3 py-5 text-sm bg-white border-b border-gray-200 text-gray-600 ${style.checkboxCol}`}>
                                          <CheckBox
                                            id="myCheckbox"
                                            checked={deleteMarks.includes(
                                              value?.id,
                                            )}
                                            onChange={() =>
                                              checkboxDelete(value?.id)
                                            }
                                          />
                                        </td>
                                      )}
                                    <td className={`px-3 py-5 text-sm bg-white border-b border-gray-200 text-gray-600 ${style.indexCol}`}>
                                      {index+1}
                                    </td>
                                    <td className={`px-1 py-5 text-sm bg-white border-b border-gray-200 text-gray-600  ${style.codeCol}`}>
                                      <span className={style.codeText}>{value.markCode || "-"}</span>
                                    </td>
                                    {persFields.map((field: any, fIdx: number) => {
                                      const key = field.value;
                                      const type = getInputType(String(key));
                                      const disabled = !isEditable(field);
                                      const valueCell = formik.values.marks[index]?.[key];
                                      if (field.isSelector || field.reference) {
                                        return (
                                          <td key={`td-${fIdx}-${key}`} className="px-5 text-sm bg-white border-b border-gray-200 text-gray-600 text-center">
                                            <div className={`${style.inputField3} min-w-0`}>
                                              <Field
                                                value={valueCell || null}
                                                component={SelectCustomFormik}
                                                name={`marks[${index}].${key}`}
                                                size="xl"
                                                isMulti={false}
                                                withoutStyle={true}
                                             
                                                options={(field.value === 'sourceCode'
                                                  ? sourceCodeOptions
                                                  : (Array.isArray(field.options) ? field.options : [])
                                                ).map((option: any) => ({
                                                  label: option.label,
                                                  value: option.value,
                                                }))}
                                                placeholder={t("documentLabels.choose_option")}
                                                onChange={(val: any) => {
                                                  dispatch(setBlocker(true));
                                                  setIsFormChanged(true);
                                                  formik.setFieldValue(`marks[${index}].${key}`, val);
                                                  handleProductChange(index, key, val, formik);
                                                }}
                                                isDisabled={disabled}
                                              />
                                            </div>
                                          </td>
                                        );
                                      }
                                      if (type === "date") {
                                        return (
                                          <td key={`td-${fIdx}-${key}`} className="px-5  text-sm bg-white border-b border-gray-200 text-gray-600 text-center">
                                            <div className="min-w-0">
                                              <CalendarSelectFormik
                                                documentStatus={formik.values.status}
                                                name={`marks[${index}].${key}`}
                                                disabled={disabled}
                                                onChange={(val?: string) => {
                                                  dispatch(setBlocker(true));
                                                  setIsFormChanged(true);
                                                  const v = val ?? formik.values.marks?.[index]?.[key];
                                                  handleProductChange(index, key, v, formik);
                                                }}
                                              />
                                            </div>
                                          </td>
                                        );
                                      }
                                      return (
                                        <td key={`td-${fIdx}-${key}`} className="px-5  text-sm bg-white border-b border-gray-200 text-gray-600 text-center">
                                          <div className="min-w-0">
                                            {key === "gasCylinderId" ? (
                                              <GasCylinderIdInput
                                                disabled={disabled}
                                                value={valueCell}
                                                onChange={(nextValue: any) => {
                                                  dispatch(setBlocker(true));
                                                  setIsFormChanged(true);
                                                  formik.setFieldValue(`marks[${index}].${key}`, nextValue);
                                                  handleProductChange(index, key, nextValue, formik);
                                                }}
                                                onDebouncedCheck={async (val: string | number) => {
                                                  if (val === null || val === undefined || val === "") return;
                                                  try {
                                                    await checkBalloonCode(val);
                                                  } catch (err: any) {
                                                    setErrorModal({
                                                      singleError: true,
                                                      errorMessage: err?.response?.data?.message || err?.message || "Ошибка проверки кода баллона",
                                                    });
                                                  }
                                                }}
                                              />
                                            ) : (
                                              <Field
                                                type={type}
                                                disabled={disabled}
                                                min={type === "number" ? 0 : undefined}
                                                max={type === "number" && key === "gasVolume" ? 50 : undefined}
                                                value={valueCell}
                                                name={`marks[${index}].${key}`}
                                                onChange={(e: any) => {
                                                  
                                                  dispatch(setBlocker(true));
                                                  setIsFormChanged(true);
                                                  let nextValue = e.target.value;
                                                  if (type === "number") {
                                                    if (typeof nextValue === "string") {
                                                      nextValue = nextValue.replace(",", ".");
                                                    }
                                                    if (Number(nextValue) < 0) nextValue = "0";
                                                    if (nextValue !== "" && !/^\d*\.?\d{0,3}$/.test(nextValue)) {
                                                      return;
                                                    }
                                                    if (key === "gasVolume") {
                                                      const num = Number(nextValue);
                                                      if (!Number.isNaN(num) && num > 50) {
                                                        nextValue = "50";
                                                      }
                                                    }
                                                  }
                                                  formik.setFieldValue(`marks[${index}].${key}`, nextValue);
                                                  handleProductChange(index, key, nextValue, formik);
                                                }}
                                                placeholder={t("documentLabels.choose_option")}
                                                className={`w-full border-gray-300 text-black placeholder-gray-400 text-center p-[20px] ${style.placeholder}`}
                                              />
                                            )}
                                          </div>
                                        </td>
                                      );
                                    })}
                                    {(status === "new" ||
                                      status === "DRAFT") && (
                                        <td className={`px-2 py-5 text-sm bg-white border-b border-gray-200 text-gray-600 ${style.trash} `}>
                                          <img
                                            src="/icons/trash.svg"
                                            className="cursor-pointer max-w-[20px] w-[20px] h-[20px] mx-auto"
                                            onClick={() =>
                                              setIsDeleteModalOpen([value?.id])
                                            }
                                          ></img>
                                        </td>
                                      )}
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan={6} className="text-center py-5">
                                <div>
                                  <EmptyListPlaceholderContent
                                    title={t("documents_upload.noData")}/>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {deleteMarks.length > 0
              ?
              <div className="pt-5 px-5 text-gray-600 font-medium">
                {t("documents_upload.selectedCount", {
                  selectedCount: deleteMarks.length,
                  totalItems: tableData?.totalItems || 0,
                })}

              </div>
              :
              <div className="pt-5 px-5 text-gray-600 font-medium">
                {t("documents_upload.selectedCount", {
                  selectedCount: 0,
                  totalItems: tableData?.totalItems || 0,
                })}

              </div>
            }
                    {formik.values.marks.length > 0 ? (
                      <Pagination
                        totalItems={formik.values.marks?.length}
                        totalPages={Math.ceil(
                          formik.values.marks?.length / pagination.pageSize,
                        )}
                        pagination={pagination}
                        setPagination={setPagination}
                      />
                    ) : null}
                  </div>
                  <ModalComponent
                    isOpen={!!isDeleteModalOpen}
                    onClose={() => setIsDeleteModalOpen(null)}
                    headerContent={
                      <h1 className="h__modal">
                        {t("documentNotification.notification")}
                      </h1>
                    }
                    content={
                      <p className="p__modal">
                        {deleteMarks.length > 0
                          ? locale.includes('ru')
                            ? deleteMarks.length % 10 === 1 && deleteMarks.length % 100 !== 11
                              ? t("productPersonalization.confirm_delete_start") + deleteMarks.length + t("productPersonalization.confirm_delete_end_v3")
                              : deleteMarks.length % 10 >= 2 && deleteMarks.length % 10 <= 4 && (deleteMarks.length % 100 < 10 || deleteMarks.length % 100 >= 20)
                                ? t("productPersonalization.confirm_delete_start") + deleteMarks.length + t("productPersonalization.confirm_delete_end_v1")
                                : t("productPersonalization.confirm_delete_start") + deleteMarks.length + t("productPersonalization.confirm_delete_end_v2")
                            : deleteMarks.length + t("productPersonalization.confirm_delete_marks")
                          : locale.includes('ru')
                            ? "Вы действительно хотите удалить 1 марку?"
                            : "1 мөртаңбаны жоюға сенімдісіз бе?"
                        }
                      </p>
                    }
                    customContent={
                      <div className="flex flex-row gap-[10px]">
                        <ModalButton
                          type="button"
                          color="grey"
                          onClick={() => {
                            setIsDeleteModalOpen(null);
                          }}
                        >
                          {t("mainButtons.cancel")}
                        </ModalButton>
                        <ModalButton
                          type="button"
                          onClick={() => {
                            isDeleteModalOpen &&
                              handleDelete(
                                ProductPersonalizationId,
                                jewelryId,
                                isDeleteModalOpen,
                              );
                            setIsDeleteModalOpen(null);
                            onLoad();
                          }}
                        >
                          {t("mainButtons.delete")}
                        </ModalButton>
                      </div>
                    }
                  />
                  <ModalComponent
                    isOpen={errorModal}
                    onClose={() => setErrorModal(null)}
                    headerContent={
                      <h1 className="h__modal">
                        {t("documentNotification.notification")} -{" "}
                        {t("documentNotification.check_fields")}:
                      </h1>
                    }
                    content={
                      <div className="error-list">
                        <ul>
                          {errorModal && errorModal?.length > 0 ? (
                            errorModal.map((error: any, index: any) => (
                              <li
                                className="border-b border-gray-300 py-1"
                                key={index}
                              >
                                {t(`error_dictionary.${error}`)}
                              </li>
                            ))
                          ) : (
                            <li>{t("documentNotification.no_errors")}</li>
                          )}
                        </ul>
                      </div>
                    }
                    customContent={
                      <ModalButton
                        type="button"
                        onClick={() => {
                          setErrorModal(null);
                        }}
                      >
                        {t("mainButtons.accept")}
                      </ModalButton>
                    }
                  />
                  <ModalComponent
                    isOpen={errorModal?.singleError}
                    onClose={() => setErrorModal(null)}
                    headerContent={
                      <h1 className="h__modal">
                        {" "}
                        {t("documentNotification.notification")}
                      </h1>
                    }
                    content={
                      <div className="error-list">
                        <p className="border-b border-gray-300 py-1">
                          {t("documentStatus.error")}:{" "}
                          {errorModal?.errorMessage}
                        </p>
                      </div>
                    }
                    customContent={
                      <ModalButton
                        type="button"
                        onClick={() => {
                          setErrorModal(null);
                        }}
                      >
                        {t("mainButtons.accept")}
                      </ModalButton>
                    }
                  />
                  {isOrderNumberModal && (
                    <AddByOrderNumber
                      isOpen={isOrderNumberModal}
                      setIsOpen={setIsOrderNumberModal}
                      documentId={ProductPersonalizationId}
                      toggleOnLoad={toggleOnLoad}
                      setToggleOnLoad={setToggleOnLoad}
                      personalization={{
                        documentId: ProductPersonalizationId,
                        productId: jewelryId,
                        productInfo: initialValues?.productInfo,
                      }}
                      setErrorModal={setErrorModal}
                      // onLoadingChange={handleLoadingState}
                    />
                  )}

                  <DocumentsSearch
                    isOpen={isDocumentSearchModalOpen}
                    setIsOpen={setIsDocumentSearchModalOpen}
                    documentId={ProductPersonalizationId}
                    productGroupId={initialValues?.productGroupId}
                    toggleOnLoad={toggleOnLoad}
                    setToggleOnLoad={setToggleOnLoad}
                    personalization={{
                      documentId: ProductPersonalizationId,
                      productId: jewelryId,
                      productInfo: initialValues?.productInfo,
                    }}
                  />
                  <DocumentUpload
                    isOpen={isFileUploadModalOpen}
                    setIsOpen={setIsFileUploadModalOpen}
                    documentId={ProductPersonalizationId}
                    toggleOnLoad={toggleOnLoad}
                    setToggleOnLoad={setToggleOnLoad}
                    personalization={{
                      documentId: ProductPersonalizationId,
                      productId: jewelryId,
                    }}
                  />
                  <MarkScan
                    isOpen={isMarkScanModal}
                    setIsOpen={setIsMarkScanModal}
                    documentId={ProductPersonalizationId}
                    toggleOnLoad={toggleOnLoad}
                    setToggleOnLoad={setToggleOnLoad}
                    personalization={{
                      documentId: ProductPersonalizationId,
                      productId: jewelryId,
                    }}
                  />
                  <CheckResult
                    isOpen={isCheckOpen}
                    setIsOpen={setIsCheckOpen}
                    problemMarks={isCheckOpen}
                    docId={ProductPersonalizationId}
                  />

                  {/* <AlertBox isOpen={alertOpen} setIsOpen={setAlertOpen} /> */}
                  {isLoading && <Loader />}
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ProductPersonalizationOrders;
